<template lang="html">
  <div v-if="progress" class="leftbox" style="overflow-y: hidden !important; justify-content: center; align-items: center;
    display: flex;">
    <v-layout align-center justify-center>
      <v-progress-circular :size="100" :width="8" indeterminate color="blue"></v-progress-circular>
    </v-layout>
  </div>
  <div style="overflow-y: hidden !important;" class="leftbox" v-else>
    <v-toolbar style="background-color: white !important;">
      <v-btn icon @click="toPage()">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <h2>{{eventname}}</h2>
    </v-toolbar>
    <v-tabs slot="extension" v-model="tabs" fixed-tabs color="transparent" icons-and-text centered>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1" :key="1">
        รายชื่อ
        <v-icon style="font-size: 25px !important;color: #607d8b !important;">list</v-icon>
      </v-tab>
      <v-tab href="#tab-2" :key="2">
        บรอดแคสต์ข้อความ
        <v-icon style="font-size: 25px !important;color: #607d8b !important;">chat</v-icon>
      </v-tab>
      <v-tab href="#tab-3" :key="3">
        บรอดแคสต์รูปภาพ, ไฟล์
        <v-icon style="font-size: 25px !important;color: #607d8b !important;">fas fa-file</v-icon>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs" class="white elevation-1">
      <v-tab-item id="tab-1" style="height: calc(100vh - 64px); overflow-y: hidden;">
        <v-layout row wrap align-center justify-center>
          <v-flex xs9 sm9 md9 xl9 lg9>
            <v-select
            :items="itemsselect"
            item-text="text"
            item-value="value"
            v-model="selectKey"
            style="width: 150px;display: -webkit-inline-box; margin-right: 50px;"
          ></v-select>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="'ค้นหา' + serchtitle(selectKey)"
            style="width: 300px;display: -webkit-inline-box;"
            v-if="selectKey == 'last_name' || selectKey == 'sur_name' || selectKey == 'phone' || selectKey == 'store_name'"
          ></v-text-field>
          </v-flex>
          <v-flex xs2 sm2 md2 xl2 lg2>
            <download-excel
                class   = "btn btn-default btnloadfile"
                :data   = "listfriend"
                :fields = "json_fields"
                type    = "xls"
                name    = "รายชื่อผู้เข้าร่วมงาน.xls"
                v-if="listfriend.length != 0"
                >
                ดาวน์โหลดไฟล์
            </download-excel>
            <v-btn class="btn btn-default btnloadfiledisabled" v-else disabled>ดาวน์โหลดไฟล์</v-btn>
          </v-flex>
        </v-layout>
        <v-list three-line v-if="FilterFriendList.length !== 0" style="margin-bottom: 20vh;">
          <v-data-table
            :headers="headers"
            :items="FilterFriendList"
            :loading="loading"
            hide-actions
            class=""
            style="height: calc(100vh - 280px); overflow-y: scroll;"
          >
          <template slot="headers" slot-scope="props">
            <tr style="text-align: center;">
              <th
                v-for="(header, index) in props.headers"
                class="headertable"
                :key="index"
              >
                {{ header.text }}
                <v-icon small v-if="header.value && stateDate === 'new'" @click="changestateDate('old')">arrow_upward</v-icon>
                <v-icon small v-else-if="header.value && stateDate === 'old'"  @click="changestateDate('new')">arrow_downward</v-icon>
              </th>
            </tr>
          </template>
            <template v-slot:items="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.surname }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.phone }}</td>
              <td>{{ props.item.position }}</td>
              <td>{{ props.item.store_name }}</td>
              <td>{{ momentday(props.item.timestamp) }}</td>
            </template>
          </v-data-table>
        </v-list>
        <v-list v-else>
          <v-layout align-center justify-center column fill-height>
            <v-img :src="require('../assets/robot1.png')" style="width: 100px;"></v-img>
            <h4>ไม่พบรายชื่อผู้เข้าร่วมงาน</h4>
          </v-layout>
        </v-list>
      </v-tab-item>

      <v-tab-item id="tab-2" style="height: calc(100vh - 64px);">
        <v-flex xs12 xl12 md12 sm12 lg12>
          <v-list>
            <v-flex xs12 xl12 md12 sm12 lg12 style="height: calc(100vh - 200px);" class="scrolling-wrapper">
              <template>
                <v-layout justify-center align-center style="margin-top: 15px; padding-right: 25px;padding-left: 25px;">
                  <!-- <v-text-field  label="ข้อความที่ต้องการบรอดแคสต์..." solo  v-model="message" style="color: white !important;"></v-text-field> -->
                  <v-textarea solo name="input-7-4"
                    label="ข้อความที่ต้องการบรอดแคสต์..."
                    v-model="message"
                    style="color: white !important;"
                    ></v-textarea>
                </v-layout>
                <v-layout justify-center align-center row wrap v-if="message == ''">
                  <v-btn v-on:click="sendbroadcast_category()" disabled class="buttonsubmit">ส่งข้อความตามหมวดหมู่</v-btn>
                  <v-btn v-on:click="sendbroadcast_event()" disabled class="buttonsubmit">ส่งข้อความตามอีเวนท์</v-btn>
                  <v-btn v-on:click="clear()" class="buttoncancel">ยกเลิก</v-btn>
                </v-layout>
                <v-layout justify-center align-center row wrap v-else>
                  <v-btn v-on:click="sendbroadcast_category()" :loading="loading_catagory" :disabled="loading_catagory_dis" class="buttonsubmit">ส่งข้อความตามหมวดหมู่</v-btn>
                  <v-btn v-on:click="sendbroadcast_event()" :loading="loading_event" :disabled="loading_event_dis" class="buttonsubmit">ส่งข้อความตามอีเวนท์</v-btn>
                  <v-btn v-on:click="clear()" class="buttoncancel">ยกเลิก</v-btn>
                </v-layout>
              </template>
            </v-flex>
          </v-list>
        </v-flex>
      </v-tab-item>

      <v-tab-item id="tab-3" style="height: calc(100vh - 64px);" class="scrolling-wrapper">
        <v-flex xs12 xl12 md12 sm12 lg12>
          <v-list>
            <v-flex xs12 xl12 md12 sm12 lg12 style="height: calc(100vh - 200px);" class="scrolling-wrapper">
              <template>
                <v-flex xs12 style="display: flex; justify-content: center;">
                  <!-- <input type="file" ref="fileTest" style="display: none;" @change="setFileName()"> -->
                  <div class="borderfile" v-if="fileName !==''">
                    <!-- <a class="close-classic" v-if="fileData" @click="reset()"></a> -->
                    <div  v-if="extension(fileName) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center;">
                      <img  id="img_file" v-if="fileData" style="height: 150px !important; width: 150px !important; display: flex; justify-content: center;" />
                        <b class="text2">{{ fileName }}</b>
                    </div>
                    <div v-else style="text-align: center; display: grid; justify-content: center;" >
                      <v-icon style="font-size: 70px !important; color: #1a222c;display: flex;justify-content: center; margin-top: 10px;">{{ extension(fileName)}}</v-icon>
                      <b class="text2">{{ fileName }}</b>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <form ref="fileform" style="margin-top: 30px; height: 100px;">
                    <img :src="require('../assets/robot1.png')" style="width: 60px;"/>
                    <label>
                      <b class="CSChatThai" style="text-decoration: underline;cursor: pointer;text-indent: 5em;">เลือกไฟล์</b>
                      <input type="file" ref="fileTest"  @change="setFileName()" style="display: none !important;" />
                    </label>
                  </form>
                </v-flex>
                <v-layout justify-center align-center row wrap v-if="fileData == ''">
                  <!-- <v-btn v-if="fileData == ''" disabled class="buttonsubmit">ส่งไฟล์</v-btn> -->
                  <v-btn @click="send_broadcastfile_catagory()" disabled class="buttonsubmit">ส่งไฟล์ตามหมวดหมู่</v-btn>
                  <v-btn @click="send_broadcastfile_event()" disabled class="buttonsubmit">ส่งไฟล์ตามอีเวนท์</v-btn>
                  <v-btn @click="reset()" class="buttoncancel">ยกเลิก</v-btn>
                </v-layout>
                <v-layout justify-center align-center row wrap v-else>
                  <v-btn @click="send_broadcastfile_catagory()" :loading="loading_catagory" :disabled="loading_catagory_dis" class="buttonsubmit">ส่งไฟล์ตามหมวดหมู่</v-btn>
                  <v-btn @click="send_broadcastfile_event()" :loading="loading_event" :disabled="loading_event_dis" class="buttonsubmit">ส่งไฟล์ตามอีเวนท์</v-btn>
                  <v-btn @click="reset()" class="buttoncancel">ยกเลิก</v-btn>
                </v-layout>
              </template>
            </v-flex>
          </v-list>
        </v-flex>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
// var _ = require('lodash')
import Vue from 'vue'
import { Momenttime, Decode } from '@/services'
import { sync } from 'vuex-pathify'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)
var _ = require('lodash')
export default {
  data: () => ({
    loading_event: false,
    loading_catagory: false,
    loading_event_dis: false,
    loading_catagory_dis: false,
    tabs: 'tab-1',
    progress: false,
    fileName: '',
    isLoading: false,
    fileData: '',
    loading: false,
    message: '',
    tokenservice: 'Bearer ',
    listfriend: [],
    search: '',
    eventname: '',
    totalDesserts: 0,
    pagination: {},
    headers: [
      { text: 'ชื่อ', value: false },
      { text: 'นามสกุล', value: false },
      { text: 'อีเมล', value: false },
      { text: 'หมายเลขโทรศัพท์', value: false },
      { text: 'ตำแหน่ง', value: false },
      { text: 'ชื่อร้าน', value: false },
      { text: 'วันที่', value: true }
    ],
    stateDate: 'new',
    selectKey: 'sur_name',
    itemsselect: [
      { text: 'ชื่อ', value: 'sur_name' },
      { text: 'นามสกุล', value: 'last_name' },
      { text: 'เบอร์โทร', value: 'phone' },
      { text: 'ชื่อร้าน', value: 'store_name' }
    ],
    json_fields: {
      'ชื่อ': 'name',
      'นามสกุล': 'surname',
      'อีเมล': 'email',
      'หมายเลขโทรศัพท์': 'phone',
      'ตำแหน่ง': 'position',
      'ชื่อร้าน': 'store_name',
      'วันที่': {
        field: 'timestamp',
        callback: (value) => {
          return Momenttime.momentdatethaievent(value)
        }
      }
    },
    json_meta: [
      [
        {
          'key': 'charset',
          'value': 'utf-8'
        }
      ]
    ],
    tokenuser: ''
  }),
  created () {
    this.tokenuser = Decode.decodeToken(localStorage.getItem('tokenuser'))
    this.geteventfriend()
  },
  computed: {
    FilterFriendList () {
      if (this.search !== '' && this.search !== null) {
        if (this.selectKey === 'sur_name') {
          return this.listfriend.filter(post => {
            return post.name.toLowerCase().includes(this.search.toLowerCase())
          })
        } else if (this.selectKey === 'last_name') {
          return this.listfriend.filter(post => {
            return post.surname.toLowerCase().includes(this.search.toLowerCase())
          })
        } else if (this.selectKey === 'phone') {
          return this.listfriend.filter(post => {
            return post.phone.toLowerCase().includes(this.search.toLowerCase())
          })
        } else if (this.selectKey === 'store_name') {
          return this.listfriend.filter(post => {
            return post.store_name.toLowerCase().includes(this.search.toLowerCase())
          })
        }
      } else {
        return this.listfriend
      }
    },
    ...sync('*')
  },
  watch: {
    socket_register_event (data) {
      // console.log(data)
      this.listfriend.unshift(data)
    }
    // selectKey () {
    //   if (this.selectKey === 'state') {
    //     // console.log(this.selectKey)
    //     this.search = 'open'
    //     // console.log(this.keysearchproblem)
    //   } else {
    //     this.search = ''
    //   }
    // }
  },
  mounted () {
  },
  methods: {
    serchtitle (data) {
      var index = _.findIndex(this.itemsselect, function (o) { return o.value === data })
      return this.itemsselect[index].text
    },
    changestateDate (state) {
      // console.log(state)
      this.listfriend = _.sortBy(this.listfriend, function (dateObj) {
        return new Date(dateObj.timestamp)
      })
      if (state === 'old') {
        // console.log('old')
        this.stateDate = 'old'
      } else {
        // console.log('new')
        this.listfriend.reverse()
        this.stateDate = 'new'
      }
    },
    momentday (data) {
      return Momenttime.momentdatethaievent(data)
    },
    toPage () {
      // this.$router.push('/account/settings/event/' + this.$route.params.id)
      this.$router.push('/account/' + this.$route.params.id)
    },
    geteventfriend () {
      this.progress = true
      localStorage.getItem('eventid')
      this.eventname = localStorage.getItem('eventname')
      var eventid = localStorage.getItem('eventid')
      var body = { tokenuser: this.tokenuser, tokenbot: this.$route.params.id, event_id: eventid }
      this.axios.post(process.env.VUE_APP_API_DEVELOP + '/get/list_participant', body).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.listfriend = response.data.data
          this.listfriend = _.sortBy(this.listfriend, function (dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.listfriend.reverse()
        }
        // console.log(response.data)
      })
    },
    reset () {
      this.fileName = ''
      this.fileData = ''
    },
    setFileName () {
      this.fileName = this.$refs.fileTest.files[0].name
      var typeFile = this.$refs.fileTest.files[0].type
      this.fileData = this.$refs.fileTest.files[0]
      // console.log(this.$refs.fileTest.files[0].size / 1024 / 1024)
      if (this.$refs.fileTest.files[0].size / 1024 / 1024 > 25) {
        this.$swal({ title: 'ไฟล์ของท่านมีขนาดเกิน 25 MB', type: 'warning' })
        this.reset()
      }
      if (typeFile.search('image') !== -1) {
        var fr = new FileReader()
        fr.onload = function () {
          document.getElementById('img_file').src = fr.result
        }
        fr.readAsDataURL(this.fileData)
      }
    },
    extension (files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var file = ['ai', 'ps', 'psd']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (file.includes(extension)) {
        return 'fas fa-file'
      } else {
        return 'fas fa-file-alt'
      }
    // return extension[extension.length-1]
    },
    sendbroadcast_category () {
      this.loading_catagory = true
      this.loading_event_dis = true
      if (this.listfriend.length !== 0) {
        this.$swal({
          title: 'ยืนยันการส่งข้อความ',
          text: 'คุณต้องการส่งข้อความถึงเพื่อนที่เข้าร่วมงานทั้งหมดใช่หรือไม่?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            // this.loading_catagory = false
            // this.loading_event_dis = false
            var body = { bot_id: this.$route.params.id, category: localStorage.getItem('category'), message: this.message }
            // console.log(body)
            this.axios.post(process.env.VUE_APP_API_IMAGE + '/event/broadcast_message_event', body).then((response) => {
              if (response.data.status === 'success') {
                this.$swal({
                  title: 'ส่งข้อความสำเร็จ',
                  type: 'success',
                  showConfirmButton: true,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'ตกลง'
                })
                this.loading_catagory = false
                this.loading_event_dis = false
                this.message = ''
              } else {
                this.loading_catagory = true
                this.loading_event_dis = true
              }
            })
          } else {
            this.loading_catagory = false
            this.loading_event_dis = false
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$swal({
          text: 'ไม่สามารถส่งข้อความ เนื่องจากยังไม่มีรายชื่อผู้เข้าร่วมงาน',
          type: 'warning',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ตกลง'
        })
        this.loading_catagory = false
        this.loading_event_dis = false
        this.message = ''
      }
    },
    sendbroadcast_event () {
      this.loading_event = true
      this.loading_catagory_dis = true
      if (this.listfriend.length !== 0) {
        this.$swal({
          title: 'ยืนยันการส่งข้อความ',
          text: 'คุณต้องการส่งข้อความถึงเพื่อนที่เข้าร่วมงานทั้งหมดใช่หรือไม่?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            // this.loading_event = false
            // this.loading_catagory_dis = false
            var body = { bot_id: this.$route.params.id, event_id: localStorage.getItem('eventid'), message: this.message }
            // console.log(body)
            this.axios.post(process.env.VUE_APP_API_IMAGE + '/event/broadcast_message_event', body).then((response) => {
              if (response.data.status === 'success') {
                this.$swal({
                  title: 'ส่งข้อความสำเร็จ',
                  type: 'success',
                  showConfirmButton: true,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'ตกลง'
                })
                this.loading_event = false
                this.loading_catagory_dis = false
                this.message = ''
              } else {
                this.loading_event = true
                this.loading_catagory_dis = true
              }
            })
          } else {
            this.loading_event = false
            this.loading_catagory_dis = false
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$swal({
          text: 'ไม่สามารถส่งข้อความ เนื่องจากยังไม่มีรายชื่อผู้เข้าร่วมงาน',
          type: 'warning',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ตกลง'
        })
        this.loading_event = false
        this.loading_catagory_dis = false
        this.message = ''
      }
    },
    send_broadcastfile_event () {
      if (!this.fileData) {
        this.$swal({ title: 'กรุณาเลือกไฟล์', type: 'warning' })
        return
      }
      if (this.listfriend.length !== 0) {
        this.$swal({
          title: 'ยืนยันการส่งข้อความ',
          text: 'คุณต้องการส่งข้อความถึงเพื่อนที่เข้าร่วมงานทั้งหมดใช่หรือไม่?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            this.loading_event = true
            this.loading_catagory_dis = true
            // var friend = []
            // var tokenfriend = []
            // friend = this.listfriend
            // var pluck = require('lodash.pluck')
            // tokenfriend = pluck(friend, 'user_id')
            var data = new FormData()
            data.append('bot_id', this.$route.params.id)
            data.append('file', this.$refs.fileTest.files[0])
            data.append('event_id', localStorage.getItem('eventid'))
            this.axios.post(process.env.VUE_APP_API_IMAGE + '/event/broadcast_file_event', data).then((response) => {
              if (response.data.status === 'success') {
                this.$swal({
                  title: 'ส่งข้อความสำเร็จ',
                  type: 'success',
                  showConfirmButton: true,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'ตกลง'
                })
                this.reset()
                this.loading_event = false
                this.loading_catagory_dis = false
              } else {
                this.loading_event = true
                this.loading_catagory_dis = true
              }
            })
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$swal({
          text: 'ไม่สามารถส่งข้อความ เนื่องจากยังไม่มีรายชื่อผู้เข้าร่วมงาน',
          type: 'warning',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ตกลง'
        })
        this.loading_event = false
        this.loading_catagory_dis = false
        this.reset()
      }
    },
    send_broadcastfile_catagory () {
      if (!this.fileData) {
        this.$swal({ title: 'กรุณาเลือกไฟล์', type: 'warning' })
        return
      }
      if (this.listfriend.length !== 0) {
        this.$swal({
          title: 'ยืนยันการส่งข้อความ',
          text: 'คุณต้องการส่งข้อความถึงเพื่อนที่เข้าร่วมงานทั้งหมดใช่หรือไม่?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            this.loading_catagory = true
            this.loading_event_dis = true
            // var friend = []
            // var tokenfriend = []
            // friend = this.listfriend
            // var pluck = require('lodash.pluck')
            // tokenfriend = pluck(friend, 'user_id')
            var data = new FormData()
            data.append('bot_id', this.$route.params.id)
            data.append('file', this.$refs.fileTest.files[0])
            data.append('category', localStorage.getItem('category'))
            this.axios.post(process.env.VUE_APP_API_IMAGE + '/event/broadcast_file_event', data).then((response) => {
              if (response.data.status === 'success') {
                this.$swal({
                  title: 'ส่งข้อความสำเร็จ',
                  type: 'success',
                  showConfirmButton: true,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'ตกลง'
                })
                this.reset()
                this.loading_catagory = false
                this.loading_event_dis = false
              } else {
                this.loading_catagory = true
                this.loading_event_dis = true
              }
            })
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$swal({
          text: 'ไม่สามารถส่งข้อความ เนื่องจากยังไม่มีรายชื่อผู้เข้าร่วมงาน',
          type: 'warning',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ตกลง'
        })
        this.loading_catagory = false
        this.loading_event_dis = false
        this.reset()
      }
    },
    clear () {
      this.message = ''
    }
  }
}
</script>

<style lang="css" scoped>
>>>.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    /* padding-right: 12px; */
    /*font-size: 14px;*/
    font-size: 14px;
    resize: none;
    height: 75px !important;
}
.btnloadfile {
  border-color: #607d8b;
  border-style: solid;
  background-color: #607d8b;
  border-radius: 8px;
  color: white;
  height: 30px;
  width: 120px;
  cursor: pointer;
}
.btnloadfiledisabled {
  /* border-color: #607d8b;
  border-style: solid; */
  background-color: #607d8b;
  border-radius: 8px;
  color: white;
  height: 30px;
  width: 120px;
  cursor: pointer;
}
.btnloadfile:hover {
  border-color: #566c77;
  border-style: solid;
  background-color: #566c77;
  border-radius: 8px;
  color: white;
  height: 30px;
  width: 120px;
  cursor: pointer;
}
.text2 {
  white-space: nowrap;
  width: 155px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 300px !important;
  height: 185px !important;
  position: relative;
  background: white;
}
.containers {
  width: 576px; margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}

[class*='close-'] {
  color: #777;
  font: 27px/100% arial, sans-serif;
  position: absolute;
  right: 15px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
.buttonsubmit {
  background-color: #607d8b !important;
  border-radius: 8px !important;
  color: white !important;
  text-transform: none !important;
}
.buttoncancel {
  border-radius: 8px !important;
  color: #4c4c4c !important;
  text-transform: none !important;
  border-color: #8080807d !important;
  border-style: solid !important;
  border-width: thin !important;
}
.fontchat {
  color: gray;
  font-size: 12px;
}
.leftbox {
  height: calc(100vh - 64px);
  background-color: #fff !important;
  overflow: hidden;
}
>>>.v-input__slot {
  width: 100%;
  border-radius: 20px;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  height: 100px !important;
  border-radius: 20px !important;
  width: 100% !important;
  border-style: solid !important;
  border-color: #c1c1c1 !important;
  box-shadow: none !important;
  border-width: thin !important;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 2px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
>>>.v-table__overflow {
  width: 100% !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
}
</style>
